<div class="intro-question-challenge">
  <div class="intro-background" [class.-inside]="animationState.background"></div>

  <div class="intro-content">
    <div
      class="discipline-badge mb-20"
      [class.-inside]="animationState.discipline == 'inside'"
      [class.-gone]="animationState.discipline == 'gone'"
    >
      <div class="badge-content">
        <img [src]="challengeSession.challenge.specialty.icon" />
        <span>{{ challengeSession.challenge.specialty.name }}</span>
      </div>
    </div>

    <div class="question-number" [class.-inside]="animationState.questionNumber">
      {{ 'question.question' | translate }} {{ currentChallengeQuestion.index + 1 }}
    </div>

    <div class="question-total" [class.-inside]="animationState.questionTotal">
      {{
        'challenge.question_number'
          | translate
            : {
                numQuestion: currentChallengeQuestion.index + 1,
                totalQuestion: challengeSession.challengeQuestions.length
              }
      }}
    </div>

    <img
      src="assets/assets-site/images/svg-illustrations/flash-intro-question-challenge.svg"
      class="flash-img"
      [class.-inside]="animationState.flashImg == 'inside'"
      [class.-gone]="animationState.flashImg == 'gone'"
    />
  </div>
</div>
